import { useTranslation } from "react-i18next";
import { Typography } from "@mui/material";
import CustomImage from "components/CustomImage";
import CustomButton from "components/CustomButton";
import {useNavigate} from "react-router-dom";

const Error = () => {
  const { t } = useTranslation();
    const navigate = useNavigate()
  const handleClick = () => {
      navigate("/home");
  };

  return (
    <div className="d-flex flex-column align-items-center justify-content-center vh-100 p-5">
      <CustomImage
        src={process.env.PUBLIC_URL + "/assets/pngs/404.png"}
        style={{
          width: '20%',
        }}
        alt="Error"
      />
      {/*<Typography variant="h1" className="mt-4 mb-1">*/}
      {/*  404*/}
      {/*</Typography>*/}
      <Typography variant="h3" className="mt-3 ml-4" color="textPrimary" sx={{letterSpacing: 8}}>
        {t("PAGE NOT FOUND")}
      </Typography>
      <CustomButton
        title="Go Home"
        onClick={handleClick}
        className="mt-5 px-5"
      />
    </div>
  );
};

export default Error;
